import React from "react";
import { DataGrid } from "@mui/x-data-grid";

export default function ApplicantsAnswersScores() {
  return (
    <div>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={row => row.id}
        hideFooter={true}
        initialState={{
          sorting: {
            sortModel: [{ field: "totalRank", sort: "desc" }],
          },
        }}
        sx={{
          backgroundColor: "white",
        }}
      />
    </div>
  );
}

const totalRanking = (value, row) => {
  let sum =
    row.employmentFormScore +
    row.timeCommitFormScore +
    row.opportunitiesFormScore +
    row.gainFormScore +
    row.certificationFormScore +
    row.PMIFormScore +
    row.agileCertFormScore +
    row.sprintCommitFormScore +
    row.commentsFormScore +
    row.hearFormScore;
  return sum;
};

const columns = [
  {
    field: "totalRank",
    headerName: "Total Ranking",
    width: 100,
    valueGetter: totalRanking,
  },
  {
    field: "submitDate",
    headerName: "Date Submitted",
    // align: "left",
    // headerAlign: "left",
    width: 110,
  },
  { field: "fName", headerName: "First Name" },
  { field: "lName", headerName: "Last Name" },
  { field: "email", headerName: "Email" },
  { field: "phone", headerName: "Best phone number to reach you" },
  { field: "city", headerName: "City" },
  { field: "state", headerName: "State" },
  { field: "country", headerName: "Country" },
  { field: "linkedIn", headerName: "Please provide your LinkedIn Public Profile URL:" },
  { field: "employmentStatus", headerName: "What is your current employment status?" },
  {
    field: "employmentFormScore",
    headerName: "Form Score",
    type: "number",
    align: "left",
  },
  {
    field: "employmentAssignedScore",
    headerName: "Assigned Score",
    type: "number",
    editable: true,
    align: "left",
  },
  {
    field: "timeCommit",
    headerName:
      "What is the average amount of time you can commit to volunteering with SVPM? (in hours/week)",
  },
  {
    field: "timeCommitFormScore",
    headerName: "Form Score",
    type: "number",
    align: "left",
  },
  {
    field: "timeCommitAssignedScore",
    headerName: "Assigned Score",
    type: "number",
    editable: true,
    align: "left",
  },
  {
    field: "opportunities",
    headerName: "Which volunteer opportunities are you interested in?",
  },
  {
    field: "opportunitiesFormScore",
    headerName: "Form Score",
    type: "number",
    align: "left",
  },
  {
    field: "opportunitiesAssignedScore",
    headerName: "Assigned Score",
    type: "number",
    editable: true,
    align: "left",
  },
  {
    field: "gain",
    headerName:
      "What are you looking to gain in participating in the SVPM Scrum Team volunteer program?",
  },
  {
    field: "gainFormScore",
    headerName: "Form Score",
    type: "number",
    align: "left",
  },
  {
    field: "gainAssignedScore",
    headerName: "Assigned Score",
    type: "number",
    editable: true,
    align: "left",
  },
  {
    field: "certification",
    headerName: 'Do you have any of the following "Scrum" related certifications?',
  },
  {
    field: "certificationFormScore",
    headerName: "Form Score",
    type: "number",
    align: "left",
  },
  {
    field: "certificationAssignedScore",
    headerName: "Assigned Score",
    type: "number",
    editable: true,
    align: "left",
  },
  {
    field: "PMI",
    headerName: 'Do you have any of the following "PMI" related certifications?',
  },
  {
    field: "PMIFormScore",
    headerName: "Form Score",
    type: "number",
    align: "left",
  },
  {
    field: "PMIAssignedScore",
    headerName: "Assigned Score",
    type: "number",
    editable: true,
    align: "left",
  },
  {
    field: "agileCert",
    headerName: 'Do you have any of these other "Agile" related certifications?',
  },
  {
    field: "agileCertFormScore",
    headerName: "Form Score",
    type: "number",
    align: "left",
  },
  {
    field: "agileCertAssignedScore",
    headerName: "Assigned Score",
    type: "number",
    editable: true,
    align: "left",
  },
  {
    field: "sprintCommit",
    headerName: "Are you able to commit to 3 sprint release cycles?",
  },
  {
    field: "sprintCommitFormScore",
    headerName: "Form Score",
    type: "number",
    align: "left",
  },
  {
    field: "sprintCommitAssignedScore",
    headerName: "Assigned Score",
    type: "number",
    editable: true,
    align: "left",
  },
  {
    field: "startInAWeek",
    headerName: "Are you able to start volunteering within a week of your application?",
  },
  {
    field: "earliestAvalbale",
    headerName: "If no, please share your earliest available start date with us.",
  },
  {
    field: "hear",
    headerName: "how_did_you_hear_about_us",
  },
  {
    field: "hearFormScore",
    headerName: "Form Score",
    type: "number",
    align: "left",
  },
  {
    field: "hearAssignedScore",
    headerName: "Assigned Score",
    type: "number",
    editable: true,
    align: "left",
  },
  {
    field: "comments",
    headerName:
      "Please feel free to provide us with any additional comments, suggestions, or feedback.",
  },
  {
    field: "commentsFormScore",
    headerName: "Form Score",
    type: "number",
    align: "left",
  },
  {
    field: "commentsAssignedScore",
    headerName: "Assigned Score",
    type: "number",
    editable: true,
    align: "left",
  },
];

const rows = [
  {
    id: 1,
    submitDate: "10/31/2023",
    fName: "Abirami",
    lName: "Chockalingam",
    email: "chockalingam.a@northeastern.edu",
    phone: "+16507891991",
    city: "San Jose",
    state: "CA",
    country: "United States",
    linkedIn: "https://www.linkedin.com/in/abirami-chockalingam",
    employmentStatus: "Student,Graduate Seeking Employment",
    employmentFormScore: 1,
    employmentAssignedScore: 1,
    timeCommit: "15hours/week",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities:
      "scrum-team-member-developer,scrum-master,scrum-product-owner,other-positions-with-asvpm",
    opportunitiesFormScore: 1,
    opportunitiesAssignedScore: 1,
    gain: "To practice Agile and implement them on a daily basis",
    gainFormScore: 1,
    gainAssignedScore: 1,
    certification: "CSM(Scrumalliance.org)",
    certificationFormScore: 1,
    certificationAssignedScore: 1,
    PMI: "Working towards CAPM",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "None",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "Through Prof. David and I was working for more than 6months with CAM Team",
    hearFormScore: 2,
    hearAssignedScore: 2,
    comments: "I am a returning member of the CAM Team",
    commentsFormScore: 1,
    commentsAssignedScore: 1,
  },
  {
    id: 2,
    submitDate: "10/31/2023",
    fName: "Dr",
    lName: "Suman",
    email: "drfnusuman@gmail.com",
    phone: "6692644074",
    city: "Sunnyvale",
    state: "CA",
    country: "United States",
    linkedIn:
      "https://www.linkedin.com/in/suman-ph-d-physics-mba-pmp-acp-itil4-0b75b4126/",
    employmentStatus: "Between Jobs In Transition, Full Time",
    employmentFormScore: -2,
    employmentAssignedScore: -2,
    timeCommit: "6-8 hours/week",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-master,scrum-product-owner,other-positions-with-asvpm",
    opportunitiesFormScore: 0,
    opportunitiesAssignedScore: 0,
    gain: "I like collaboration with diverse individuals. The IT field is constantly evolving, I am keen to learn and share new latest trends and technologies. Streamlining processes, optimizing resources, and improving project management practices to increase efficiency and reduce waste are something I often strive for and find passion in.",
    gainFormScore: 2,
    gainAssignedScore: 2,
    certification: "CSM",
    certificationFormScore: 1,
    certificationAssignedScore: 1,
    PMI: "PMP, and PMI - ACP",
    PMIFormScore: 1,
    PMIAssignedScore: 1,
    agileCert: "SAFe",
    agileCertFormScore: 1,
    agileCertAssignedScore: 1,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "David (Davood) Bakhtnia",
    hearFormScore: 2,
    hearAssignedScore: 2,
    comments: "Looking forward to being a part of SVPM",
    commentsFormScore: 1,
    commentsAssignedScore: 1,
  },
  {
    id: 3,
    submitDate: "10/19/2023",
    fName: "JOY",
    lName: "ONIGBOGI",
    email: "joy@sdedigital.com",
    phone: "7956438972",
    city: "London",
    state: "Europe",
    country: "United Kingdom",
    linkedIn: "www.linkedin.com/in/joy-onigbogi-cmgr-csm-cspo-718433199",
    employmentStatus: "Part Time",
    employmentFormScore: 0,
    employmentAssignedScore: 0,
    timeCommit: "10-12 hours/week",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities:
      "scrum-team-member-developer,scrum-master,scrum-product-owner,other-positions-with-asvpm",
    opportunitiesFormScore: 1,
    opportunitiesAssignedScore: 1,
    gain: "I am looking to practice Agile and move with current trends.",
    gainFormScore: 1,
    gainAssignedScore: 1,
    certification: "CSM, CSPO",
    certificationFormScore: 2,
    certificationAssignedScore: 2,
    PMI: "NONE",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "NONE",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "Referral - Delaine Moore",
    hearFormScore: 1,
    hearAssignedScore: 1,
    comments: "",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
  {
    id: 4,
    submitDate: "11/17/2023",
    fName: "Jaives",
    lName: "Lundy",
    email: "jai.lundy@gmail.com",
    phone: "3364931406",
    city: "Winston Salem",
    state: "NC",
    country: "United States",
    linkedIn: "https://www.linkedin.com/in/jaiveslundy/",
    employmentStatus: "Between Jobs In Transition",
    employmentFormScore: 1,
    employmentAssignedScore: 1,
    timeCommit: "15-20 Hours/Week",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-team-member-developer,scrum-master",
    opportunitiesFormScore: 1,
    opportunitiesAssignedScore: 1,
    gain: "I am looking to further refine my scrum master experience, as my last two positions as a scrum master was implementing scrum in a telecommunications company. I want to improve my skills in a fully agile environment.",
    gainFormScore: 1,
    gainAssignedScore: 1,
    certification: "CSM (scrumalliance.org)",
    certificationFormScore: 1,
    certificationAssignedScore: 1,
    PMI: "NONE",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "NONE",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "My LinkedIn connection Eddie Drew was a volunteer and recommended SVPM to me.",
    hearFormScore: 1,
    hearAssignedScore: 1,
    comments: "",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
  {
    id: 5,
    submitDate: "11/1/2023",
    fName: "Ifeyinwa",
    lName: "Okade",
    email: "ipokade@yahoo.com",
    phone: "19197584323",
    city: "Raleigh",
    state: "NC",
    country: "United States",
    linkedIn: "www.linkedin.com/in/ify-okade",
    employmentStatus: "Between Jobs In Transition,Returning to Job Market",
    employmentFormScore: 1,
    employmentAssignedScore: 1,
    timeCommit: "8-16 hours",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-master",
    opportunitiesFormScore: 0,
    opportunitiesAssignedScore: 0,
    gain: "I am looking for a chance to hone my skills, gain more experience, and immerse myself in the Agile world",
    gainFormScore: 1,
    gainAssignedScore: 1,
    certification: "CSM",
    certificationFormScore: 1,
    certificationAssignedScore: 1,
    PMI: "NONE",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "NONE",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "From a Google search for Scrum master volunteer positions",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments:
      "I'm excited to embark on this journey of growth and learning. As a passionate advocate for continuous improvement, I look forward to challenging myself, embracing the Agile principles, and contributing my best to the team. I believe that every experience, no matter how small, can be a stepping stone to professional excellence. I value the importance of open communication, teamwork, and collaboration, as these principles lie at the core of Agile methodology.",
    commentsFormScore: 2,
    commentsAssignedScore: 2,
  },
  {
    id: 6,
    submitDate: "10/17/2023",
    fName: "Shibha",
    lName: "Tyagi",
    email: "txshibha@gmail.com",
    phone: "4698470186",
    city: "Plano",
    state: "TX",
    country: "United States",
    linkedIn: "https://www.linkedin.com/in/shibha-tyagi-55059616/",
    employmentStatus: "Between Jobs In Transition",
    employmentFormScore: 1,
    employmentAssignedScore: 1,
    timeCommit: "16 - 20 hours/ week",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-master",
    opportunitiesFormScore: 0,
    opportunitiesAssignedScore: 0,
    gain: "- Contribute in any possible way\n- Hands on experience\n- Knowledge Gain and Skill Development\n- Mentorship",
    gainFormScore: 1,
    gainAssignedScore: 1,
    certification: "CSM (scrumalliance.org)",
    certificationFormScore: 1,
    certificationAssignedScore: 1,
    PMI: "NONE",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "NONE",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "Referral from a friend",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments:
      "I am eager to learn and grow in a Scrum environment, gain valuable experience, and make a positive impact on the projects I'll be involved in.\nI believe that this experience will not only enhance my skills but also allow me to contribute to my employer's success and make a real difference. I look forward to the challenges and opportunities this program will offer, and I'm committed to giving it my all.\nPlease let me know if there are any initial steps or preparations I should be aware of before we get started. I'm ready to dive in and make the most of this incredible opportunity.",
    commentsFormScore: 1,
    commentsAssignedScore: 1,
  },
  {
    id: 7,
    submitDate: "10/26/2023",
    fName: "Abimbola",
    lName: "Unah",
    email: "Abimunah@gmail.com",
    phone: "4042875223",
    city: "Suwanee",
    state: "GA",
    country: "United States",
    linkedIn: "https://www.linkedin.com/in/abimbola-u-b689b360",
    employmentStatus: "Between Jobs In Transition",
    employmentFormScore: 1,
    employmentAssignedScore: 1,
    timeCommit: "20 hours/week",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-master,other-positions-with-asvpm",
    opportunitiesFormScore: 0,
    opportunitiesAssignedScore: 0,
    gain: "I am looking to gain valuable experience while working as part of a functioning scrum team",
    gainFormScore: 1,
    gainAssignedScore: 1,
    certification: "PSM (scrum.org)",
    certificationFormScore: 1,
    certificationAssignedScore: 1,
    PMI: "None",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "Scrum master certification( Entrylevel learning platform)",
    agileCertFormScore: 1,
    agileCertAssignedScore: 1,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "10/30/2023",
    hear: "I learnt of this program while I was surfing the internet for internship /volunteer opportunities.",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments: "",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
  {
    id: 8,
    submitDate: "10/26/2023",
    fName: "Ladreama",
    lName: "Perry",
    email: "ladreamaperry016@gmail.com",
    phone: "2523702555",
    city: "Greenville",
    state: "NC",
    country: "United States",
    linkedIn:
      "https://www.linkedin.com/in/ladreama-perry-482095b2?utm_source=share&amp;amp;utm_campaign=share_via&amp;amp;utm_content=profile&amp;amp;utm_medium=ios_app",
    employmentStatus: "Graduate Seeking Employment,Returning to Job Market",
    employmentFormScore: 1,
    employmentAssignedScore: 1,
    timeCommit: "20/hrs",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-master,scrum-product-owner,scrum-team-member-developer",
    opportunitiesFormScore: 1,
    opportunitiesAssignedScore: 1,
    gain: "Experience and more understanding of scrum duties to land a scum master role.’",
    gainFormScore: 1,
    gainAssignedScore: 1,
    certification: "Scrumalliance.com CSM",
    certificationFormScore: 1,
    certificationAssignedScore: 1,
    PMI: "None",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "None",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "Google",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments: "",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
  {
    id: 9,
    submitDate: "10/30/2023",
    fName: "Akansha",
    lName: "Saluru",
    email: "akansha_saluru@hotmail.com",
    phone: "3659982857",
    city: "Brampton",
    state: "In Canada",
    country: "Canada",
    linkedIn: "https://www.linkedin.com/in/akansha-s/",
    employmentStatus: "Returning to Job Market",
    employmentFormScore: 1,
    employmentAssignedScore: 1,
    timeCommit: "20 hours/week",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-team-member-developer,scrum-master,other-positions-with-asvpm",
    opportunitiesFormScore: 1,
    opportunitiesAssignedScore: 1,
    gain: "I'am looking to gain hands on experience in scrum and agile frameworks.",
    gainFormScore: 1,
    gainAssignedScore: 1,
    certification: "PSM1 (scrum.org)",
    certificationFormScore: 1,
    certificationAssignedScore: 1,
    PMI: "NONE",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "NONE",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "After doing my scrum master certification while I was looking for opportunities to apply my PSM1 knowledge. I heard about SVPM Scrum Team Program through google .",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments: "",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
  {
    id: 10,
    submitDate: "11/5/2023",
    fName: "Anastasia",
    lName: "Hasan",
    email: "anastasiahasan@yahoo.com",
    phone: "213-671-3811",
    city: "palm desert",
    state: "CA",
    country: "United States",
    linkedIn: "NONE",
    employmentStatus: "Graduate Seeking Employment",
    employmentFormScore: 1,
    employmentAssignedScore: 1,
    timeCommit: "10-15 hours/week",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-master",
    opportunitiesFormScore: 0,
    opportunitiesAssignedScore: 0,
    gain: "I am looking to participate in the SVPM Scrum Team Volunteer Program with the primary goal of gaining hands-on experience and practical knowledge of the Scrum Master role.",
    gainFormScore: 1,
    gainAssignedScore: 1,
    certification: "CSM",
    certificationFormScore: 1,
    certificationAssignedScore: 1,
    PMI: "NONE",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "NONE",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "I found your company by conducting a Google search. When I was researching Scrum Master Volunteer work, I came across your company. I explored your website to and learn more about your organization, its offerings, and its reputation.",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments: "I like that you offer volunteer opportunities.",
    commentsFormScore: 1,
    commentsAssignedScore: 1,
  },
  {
    id: 11,
    submitDate: "11/21/2023",
    fName: "Andrea",
    lName: "Romain",
    email: "andrearob@gmail.com",
    phone: "(404) 384-5657",
    city: "Marietta",
    state: "GA",
    country: "United States",
    linkedIn: "www.linkedin.com/in/andreamromain",
    employmentStatus: "Returning to Job Market,Between Jobs In Transition",
    employmentFormScore: 1,
    employmentAssignedScore: 1,
    timeCommit: "15-20 hrs/wk",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-master,scrum-product-owner",
    opportunitiesFormScore: 0,
    opportunitiesAssignedScore: 0,
    gain: "I'm seeking to gain hands on experience as a Product Owner and/or Scrum Master.",
    gainFormScore: 1,
    gainAssignedScore: 1,
    certification: "CSM (expired)",
    certificationFormScore: 1,
    certificationAssignedScore: 1,
    PMI: "NONE",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "NONE",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "Word of mouth from a friend of mine",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments:
      "This sounds like an exciting opportunity get to hands on experience practicing/applying SCRUM.  I look forward to learning and polishing my skills, and hope through the interaction that I'll help other do the same!",
    commentsFormScore: 1,
    commentsAssignedScore: 1,
  },
  {
    id: 12,
    submitDate: "11/28/2023",
    fName: "Wenyi",
    lName: "Chen",
    email: "letsemailwenyichen@gmail.com",
    phone: "9172572287",
    city: "Austin",
    state: "TX",
    country: "United States",
    linkedIn: "https://www.linkedin.com/in/thewenyichen/",
    employmentStatus: "Between Jobs In Transition",
    employmentFormScore: 1,
    employmentAssignedScore: 1,
    timeCommit: "15-20 hours/week",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-product-owner,scrum-master",
    opportunitiesFormScore: 0,
    opportunitiesAssignedScore: 0,
    gain: "I want to understand the agile mindset and the values it brings to the team.",
    gainFormScore: 1,
    gainAssignedScore: 1,
    certification: "CSM (scrumalliance.org)",
    certificationFormScore: 1,
    certificationAssignedScore: 1,
    PMI: "NONE",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "SP(Scale Agile), SSM(Scale Agile)",
    agileCertFormScore: 1,
    agileCertAssignedScore: 1,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "I heard from the Agile Water Cooler group.",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments: "",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
  {
    id: 13,
    submitDate: "11/20/2023",
    fName: "Kenny",
    lName: "Fan",
    email: "kleonfan@gmail.com",
    phone: "4693468760",
    city: "Carrollton",
    state: "TX",
    country: "United States",
    linkedIn: "https://www.linkedin.com/in/kenny-fan-74911a261/",
    employmentStatus: "Graduate Seeking Employment",
    employmentFormScore: 1,
    employmentAssignedScore: 1,
    timeCommit: "15",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-master",
    opportunitiesFormScore: 0,
    opportunitiesAssignedScore: 0,
    gain: "I am hoping to gain the necessary experience to be able to land my first Scrum Master job.",
    gainFormScore: 1,
    gainAssignedScore: 1,
    certification: "CSM, PSM I, PSM II",
    certificationFormScore: 2,
    certificationAssignedScore: 2,
    PMI: "None",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "None",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "I found it through Google when I was searching for volunteer Scrum Master opportunities.",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments: "",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
  {
    id: 14,
    submitDate: "10/27/2023",
    fName: "Preeti",
    lName: "Kulkarni",
    email: "preeti.torvi@gmail.com",
    phone: "14087442438",
    city: "Cupertino",
    state: "CA",
    country: "United States",
    linkedIn: "https://www.linkedin.com/in/preetikulkarnitorvi/",
    employmentStatus: "Returning to Job Market",
    employmentFormScore: 1,
    employmentAssignedScore: 1,
    timeCommit: "10",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-master",
    opportunitiesFormScore: 0,
    opportunitiesAssignedScore: 0,
    gain: "I would want to be able to do the following by participating in the SVPM Volunteer Program:\n- Learn and understand the practical application of Scrum \n- Help deliver successful projects by helping the team adopt scrum\n- Build good relationships with co-workers, stakeholders and clients\n- Grow professionally in the role of program management as a scrum master\n- Grow in my agile journey",
    gainFormScore: 2,
    gainAssignedScore: 2,
    certification: "PSM1 . working on PSM 2",
    certificationFormScore: 1,
    certificationAssignedScore: 1,
    PMI: "NONE",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "NONE",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "Google Search",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments: "",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
  {
    id: 15,
    submitDate: "10/17/2023",
    fName: "Aqlimia",
    lName: "Stroman",
    email: "anstroman@gmail.com",
    phone: "2036853792",
    city: "Dunwoody",
    state: "GA",
    country: "United States",
    linkedIn: "www.linkedin.com/in/aqlima-stroman",
    employmentStatus: "Between Jobs In Transition,Part Time",
    employmentFormScore: 1,
    employmentAssignedScore: 1,
    timeCommit: "20 hours",
    timeCommitFormScore: 2,
    timeCommitAssignedScore: 2,
    opportunities: "scrum-team-member-developer,scrum-master",
    opportunitiesFormScore: 1,
    opportunitiesAssignedScore: 1,
    gain: "As a new CSM, I am interested in gaining experience with SVPM to become the best scrum master I can be. I truly believe SVPM can do that for me.",
    gainFormScore: 1,
    gainAssignedScore: 1,
    certification: "CSM",
    certificationFormScore: 1,
    certificationAssignedScore: 1,
    PMI: "none",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "none",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "Google",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments: "",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
  {
    id: 16,
    submitDate: "10/24/2023",
    fName: "Mansvi",
    lName: "Subramaniam",
    email: "mansvi.s@gmail.com",
    phone: "4084552687",
    city: "Portland",
    state: "OR",
    country: "United States",
    linkedIn: "https://www.linkedin.com/in/mansvi-subramaniam-68944a13b/",
    employmentStatus: "Returning to Job Market",
    employmentFormScore: 1,
    employmentAssignedScore: 1,
    timeCommit: "15-20hrs",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-master",
    opportunitiesFormScore: 0,
    opportunitiesAssignedScore: 0,
    gain: "I want to gain real-time experience as a scrum master to learn and grow in the Agile envirnoment.",
    gainFormScore: 1,
    gainAssignedScore: 1,
    certification: "PSM1",
    certificationFormScore: 1,
    certificationAssignedScore: 1,
    PMI: "none",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "none",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "Google search",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments: "",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
  {
    id: 17,
    submitDate: "10/18/2023",
    fName: "Godwin",
    lName: "Oiku",
    email: "oikugodwin@gmail.com",
    phone: "5126199517",
    city: "Austin",
    state: "TX",
    country: "United States",
    linkedIn: "www.linkedin.com/in/godwinoiku",
    employmentStatus: "Between Jobs In Transition, Full Time",
    employmentFormScore: -2,
    employmentAssignedScore: -2,
    timeCommit: "20",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-master",
    opportunitiesFormScore: 0,
    opportunitiesAssignedScore: 0,
    gain: "skill development, networking opportunities, valuable experience, personal satisfaction, the opportunity to give back, personal growth, and exposure to different industries.",
    gainFormScore: 1,
    gainAssignedScore: 1,
    certification: "CSM (scrumalliance.org)",
    certificationFormScore: 1,
    certificationAssignedScore: 1,
    PMI: "PMP",
    PMIFormScore: 1,
    PMIAssignedScore: 1,
    agileCert: "SAFe",
    agileCertFormScore: 1,
    agileCertAssignedScore: 1,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "A friend of mine told me about the program",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments: "None",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
  {
    id: 18,
    submitDate: "10/26/2023",
    fName: "Carlisha",
    lName: "Bowie",
    email: "cbowie1984@gmail.com",
    phone: "2488214866",
    city: "Pontiac",
    state: "MI",
    country: "United States",
    linkedIn: "https://www.linkedin.com/in/carlisha-bowie/",
    employmentStatus: "Full Time",
    employmentFormScore: -2,
    employmentAssignedScore: -2,
    timeCommit: "8-10 hours a week",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-team-member-developer,scrum-master,scrum-product-owner",
    opportunitiesFormScore: 1,
    opportunitiesAssignedScore: 1,
    gain: "Training and experience to apply to the field",
    gainFormScore: 1,
    gainAssignedScore: 1,
    certification: "CSM scrum Alliance",
    certificationFormScore: 1,
    certificationAssignedScore: 1,
    PMI: "None",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "None",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "Janai",
    hearFormScore: 1,
    hearAssignedScore: 1,
    comments: "",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
  {
    id: 19,
    submitDate: "11/21/2023",
    fName: "OKERE",
    lName: "NWACHUKWU",
    email: "Okerenwachukwu@gmail.com",
    phone: "3464329037",
    city: "HOUSTON",
    state: "TX",
    country: "United States",
    linkedIn: "https://www.linkedin.com/in/okere",
    employmentStatus: "Part Time",
    employmentFormScore: 0,
    employmentAssignedScore: 0,
    timeCommit: "8 hours/week",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-master",
    opportunitiesFormScore: 0,
    opportunitiesAssignedScore: 0,
    gain: "I am enthusiastic about joining the SVPM Scrum Team Volunteer Program to gain practical experience in applying Scrum methodologies to real-world projects. I am eager to collaborate with diverse teams, enhance my project management skills, and contribute my energy and creativity to meaningful initiatives. Additionally, I am excited about the opportunity to learn from experienced professionals, build a network within the Scrum community, and deepen my understanding of Agile principles. Overall, I aim to leverage this program to further my professional development and make a positive impact on the teams I collaborate with.",
    gainFormScore: 1,
    gainAssignedScore: 1,
    certification: "PSM(scrum.org)",
    certificationFormScore: 1,
    certificationAssignedScore: 1,
    PMI: "NONE",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "NONE",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "N/A",
    hear: "Google search",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments: "",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
  {
    id: 20,
    submitDate: "10/31/2023",
    fName: "Bunkola",
    lName: "Olayinka",
    email: "bunkola.yinka@gmail.com",
    phone: "832-807-5358",
    city: "Fulshear",
    state: "TX",
    country: "United States",
    linkedIn: "https://www.linkedin.com/in/bunkola-olayinka-85914017a/",
    employmentStatus: "Student,Part Time",
    employmentFormScore: 0,
    employmentAssignedScore: 0,
    timeCommit: "15 hours",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-master,scrum-product-owner",
    opportunitiesFormScore: 0,
    opportunitiesAssignedScore: 0,
    gain: "I am excited about the opportunity to participate in the SVPM Scrum Team Volunteer Program, As a graduate student, I recognize the importance of practical experience in complementing theoretical knowledge. I aim to gain hands-on experience in project management, particularly within an agile framework like Scrum. My primary goal in participating in the SVPM Scrum Team Volunteer Program is to gain practical experience, develop essential skills, network with professionals, contribute to meaningful projects, and achieve personal growth while enhancing my overall qualifications. I look forward to being a part of this program and am committed to making a positive impact.",
    gainFormScore: 1,
    gainAssignedScore: 1,
    certification: "CSM (scrumalliance.org)",
    certificationFormScore: 1,
    certificationAssignedScore: 1,
    PMI: "none",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "none",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "As soon as possible",
    hear: "I heard about SVPM Scrum Team Program through a facebook group.",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments: "",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
  {
    id: 21,
    submitDate: "10/30/2023",
    fName: "Mary",
    lName: "Sule",
    email: "annabelmary38@gmail.com",
    phone: "+2348136216490",
    city: "Benin",
    state: "Africa",
    country: "Nigeria",
    linkedIn:
      "https://www.linkedin.com/in/mary-sule-13739b188?utm_source=share&amp;amp;utm_campaign=share_via&amp;amp;utm_content=profile&amp;amp;utm_medium=ios_app",
    employmentStatus: "Between Jobs In Transition",
    employmentFormScore: 1,
    employmentAssignedScore: 1,
    timeCommit: "10-20 hours",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-team-member-developer",
    opportunitiesFormScore: 1,
    opportunitiesAssignedScore: 1,
    gain: "I am willing to get hands-on experience learning and  practicing  project management scrum practices.",
    gainFormScore: 0,
    gainAssignedScore: 0,
    certification: "NONE",
    certificationFormScore: 0,
    certificationAssignedScore: 0,
    PMI: "NONE",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "NONE",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "I heard about it on google during my research on remote programs where I can get hands-on experience on scrum master",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments: "",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
  {
    id: 22,
    submitDate: "11/2/2023",
    fName: "Alexis",
    lName: "Godfrey",
    email: "alexismgodfrey@yahoo.com",
    phone: "404-901-2183",
    city: "Tallahassee",
    state: "FL",
    country: "United States",
    linkedIn: "https://www.linkedin.com/in/alexismgodfrey/",
    employmentStatus: "Between Jobs In Transition",
    employmentFormScore: 1,
    employmentAssignedScore: 1,
    timeCommit: "15-20 hours/week",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-master",
    opportunitiesFormScore: 0,
    opportunitiesAssignedScore: 0,
    gain: "Experience, community, support and give back",
    gainFormScore: 0,
    gainAssignedScore: 0,
    certification: "NONE",
    certificationFormScore: 0,
    certificationAssignedScore: 0,
    PMI: "NONE",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "Coursera/IBM",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "Meetup",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments: "Thank you for the opportunity",
    commentsFormScore: 1,
    commentsAssignedScore: 1,
  },
  {
    id: 23,
    submitDate: "11/3/2023",
    fName: "Munawwar",
    lName: "Ahsan",
    email: "munawwarsahsan@gmail.com",
    phone: "4088873687",
    city: "Sunnyvale",
    state: "CA",
    country: "United States",
    linkedIn: "https://www.linkedin.com/in/munawwar-ahsan/",
    employmentStatus: "Between Jobs In Transition",
    employmentFormScore: 1,
    employmentAssignedScore: 1,
    timeCommit: "2 - 8 hours",
    timeCommitFormScore: 2,
    timeCommitAssignedScore: 2,
    opportunities: "scrum-product-owner",
    opportunitiesFormScore: 0,
    opportunitiesAssignedScore: 0,
    gain: "Planning to Pivot to Product Management",
    gainFormScore: 0,
    gainAssignedScore: 0,
    certification: "NONE",
    certificationFormScore: 0,
    certificationAssignedScore: 0,
    PMI: "NONE",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "NONE",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "David Bakhtnia",
    hearFormScore: 2,
    hearAssignedScore: 2,
    comments: "",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
  {
    id: 24,
    submitDate: "11/15/2023",
    fName: "Joseph",
    lName: "Stafford",
    email: "Jmstaff1963@yahoo.com",
    phone: "910 988-7738",
    city: "Odessa",
    state: "FL",
    country: "United States",
    linkedIn: "https://www.linkedin.com/in/joseph-stafford/",
    employmentStatus: "Full Time",
    employmentFormScore: -2,
    employmentAssignedScore: -2,
    timeCommit: "5-8 hours/week",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-team-member-developer",
    opportunitiesFormScore: 1,
    opportunitiesAssignedScore: 1,
    gain: "I want to gain practical experience as a ScrumMaster.  I especially want to get familiar with using the software that ScrumMaster use on a day to day basis.  I obtained my CSM in preparation for applying for ScrumMaster position with Humana which is my current employer.  I have a current mentor that is a Release Train Engineer.  She has given me access to her scrum team meetings as an observer.  But I want to get some hands experience, before I apply for a position.  My goal is to be aggressive in getting as much experience as possible in the next 4 months before I apply for a position within the company.",
    gainFormScore: 1,
    gainAssignedScore: 1,
    certification: "CSM (scrumalliance.org)",
    certificationFormScore: 1,
    certificationAssignedScore: 1,
    PMI: "None",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "None",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "I searched google for volunteer opportunities for ScrumMasters",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments: "",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
  {
    id: 25,
    submitDate: "10/12/2023",
    fName: "Cregg",
    lName: "Armstrong",
    email: "armstrongcregg@gmail.com",
    phone: "4043959343",
    city: "Forest Park",
    state: "GA",
    country: "United States",
    linkedIn: "www.linkedin.com/in/creggarmstrong",
    employmentStatus: "Full Time",
    employmentFormScore: -2,
    employmentAssignedScore: -2,
    timeCommit: "8-12 hours/week",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-team-member-developer,scrum-master",
    opportunitiesFormScore: 1,
    opportunitiesAssignedScore: 1,
    gain: "I want to get a better understanding of agile framework and scrum principles so that I can use that experience to secure a full time role as a scrum master or product owner.",
    gainFormScore: 1,
    gainAssignedScore: 1,
    certification: "CSM (scrumalliance.org)",
    certificationFormScore: 1,
    certificationAssignedScore: 1,
    PMI: "None",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "None",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "No",
    earliestAvalbale: "6/22/2023",
    hear: "I googled volunteer PM/Scrum roles.",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments: "",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
  {
    id: 26,
    submitDate: "10/19/2023",
    fName: "walls",
    lName: "walls",
    email: "flosuubi@yahoo.co.uk",
    phone: "7042327314",
    city: "Matthews",
    state: "NC",
    country: "United States",
    linkedIn: "www.linkedin.com/in/ florence-walls",
    employmentStatus: "Returning to Job Market",
    employmentFormScore: 1,
    employmentAssignedScore: 1,
    timeCommit: "15",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-master",
    opportunitiesFormScore: 0,
    opportunitiesAssignedScore: 0,
    gain: "I am excited to participate in the SVPM Scrum Team Volunteer Program because I am passionate about continuous improvement and agile methodologies. My main goal is to deepen my understanding of Scrum and agile practices and apply them in real-world scenarios. By doing so, I aim to help teams become more efficient and deliver higher-quality results through agile principles.",
    gainFormScore: 0,
    gainAssignedScore: 0,
    certification: "scrumalliance.org",
    certificationFormScore: 0,
    certificationAssignedScore: 0,
    PMI: "None",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "None",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "Through Google search",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments: "",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
  {
    id: 27,
    submitDate: "10/13/2023",
    fName: "Raji",
    lName: "Pradheap",
    email: "rpradheap@gmail.com",
    phone: "4158663545",
    city: "Lathrop",
    state: "CA",
    country: "United States",
    linkedIn: "https://www.linkedin.com/in/rpradheap/",
    employmentStatus: "Between Jobs In Transition",
    employmentFormScore: 1,
    employmentAssignedScore: 1,
    timeCommit: "20",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-master,scrum-product-owner",
    opportunitiesFormScore: 0,
    opportunitiesAssignedScore: 0,
    gain: "I am a Program Manger and I am looking to gain some experience as a Scrum Master or Product owner . I also Volunteer at Hack for LA as Product Manager but still we don't fall Agile. I have extensive experience but Currently I am looking for a new job and I think gaining some Scrum Skills will be helpful for me while I can contribute my skills here.",
    gainFormScore: 0,
    gainAssignedScore: 0,
    certification: "None",
    certificationFormScore: 0,
    certificationAssignedScore: 0,
    PMI: "None",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "None",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "Google",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments: "",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
  {
    id: 28,
    submitDate: "11/6/2023",
    fName: "Alade",
    lName: "Alade",
    email: "alade.bayo84@gmail.com",
    phone: "7733759192",
    city: "Golborne",
    state: "Europe",
    country: "United Kingdom",
    linkedIn: "https://www.linkedin.com/in/rasheed-alade-psm-msc-7b084015b/",
    employmentStatus: "Graduate Seeking Employment, Full Time",
    employmentFormScore: -2,
    employmentAssignedScore: -2,
    timeCommit: "40",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-master,scrum-product-owner,other-positions-with-asvpm",
    opportunitiesFormScore: 0,
    opportunitiesAssignedScore: 0,
    gain: "My interest in the SVPM Scrum Team Volunteer Program is multifaceted. Foremost, I am keen on advancing my project management skills in a practical, hands-on environment that this program is renowned for. I am eager to dive into the Scrum methodology and Agile practices, which are pivotal in today's dynamic project management landscape.\n\n\nNetworking is another significant aspect that I am looking forward to. The opportunity to connect with like-minded professionals and industry veterans will be invaluable for mutual learning and future collaboration. I believe that the relationships fostered in professional settings such as this are often the catalysts for innovation and growth.\n\n\nAdditionally, I am passionate about contributing to meaningful projects that have the potential to make a tangible difference. Being able to apply my skills and also learn from the collective wisdom of a seasoned Scrum team is an opportunity I am particularly excited about. I expect that the collaborative environment will not only hone my technical abilities but also enhance my interpersonal skills, crucial for any leader in the making.\n\n\nFinally, I am cognizant of the recognition that comes with being part of such a reputable program. The experience and knowledge gained here will be instrumental in my professional development, and the certification attained will be a testament to the skills and expertise acquired during my tenure.\n\n\nIn essence, my participation is driven by a strong desire to grow professionally, collaborate and network with professionals, contribute significantly to projects, and achieve a standard of excellence that the SVPM Scrum Team Volunteer Program represents.\n\n\nThis response encapsulates professional growth, networking, hands-on contribution, and the pursuit of excellence as key motivators for participating in the program. Feel free to personalize this response further to align closely with your individual aspirations and professional background.",
    gainFormScore: 1,
    gainAssignedScore: 1,
    certification: "PSM1",
    certificationFormScore: 1,
    certificationAssignedScore: 1,
    PMI: "NONE",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "NONE",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "13/11/2023",
    hear: "I was looking for a volunteer scrum job then SVPM came up an google and i did my research and would be more than happy to work with SVPM.",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments: "",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
  {
    id: 29,
    submitDate: "11/22/2023",
    fName: "Ryan",
    lName: "Cook",
    email: "rygeco@gmail.com",
    phone: "2055775864",
    city: "Dallas",
    state: "TX",
    country: "United States",
    linkedIn:
      "https://www.linkedin.com/in/ryangcook?utm_source=share&amp;amp;utm_campaign=share_via&amp;amp;utm_content=profile&amp;amp;utm_medium=ios_app",
    employmentStatus: "Full Time",
    employmentFormScore: -2,
    employmentAssignedScore: -2,
    timeCommit: "10 hours/week",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-master",
    opportunitiesFormScore: 0,
    opportunitiesAssignedScore: 0,
    gain: "Keeping my knowledge and skills sharp and learning more",
    gainFormScore: 1,
    gainAssignedScore: 1,
    certification: "CSM (Scrum Alliance)",
    certificationFormScore: 1,
    certificationAssignedScore: 1,
    PMI: "None",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "None",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "Friend referred me to it",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments: "",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
  {
    id: 30,
    submitDate: "10/20/2023",
    fName: "Ayodele",
    lName: "Babaleye",
    email: "bidemibabs@gmail.com",
    phone: "+14374314010",
    city: "Pickering",
    state: "In Canada",
    country: "Canada",
    linkedIn: "https://www.linkedin.com/in/bidemibabs",
    employmentStatus: "Part Time",
    employmentFormScore: 0,
    employmentAssignedScore: 0,
    timeCommit: "15",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-product-owner",
    opportunitiesFormScore: 0,
    opportunitiesAssignedScore: 0,
    gain: "To gain theoretical and practical knowledge of Scrum and Agile methodologies",
    gainFormScore: 0,
    gainAssignedScore: 0,
    certification: "Product Manager Certificate",
    certificationFormScore: 0,
    certificationAssignedScore: 0,
    PMI: "None",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "None",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "Referred by a former manager and mentor",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments: "",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
  {
    id: 31,
    submitDate: "10/19/2023",
    fName: "Alexis",
    lName: "Godfrey",
    email: "alexismgodfrey@yahoo.com",
    phone: "4049012183",
    city: "Tallahassee",
    state: "FL",
    country: "United States",
    linkedIn: "https://www.linkedin.com/in/alexismgodfrey/",
    employmentStatus: "Returning to Job Market",
    employmentFormScore: 1,
    employmentAssignedScore: 1,
    timeCommit: "15-20 hrs/week",
    timeCommitFormScore: 0,
    timeCommitAssignedScore: 0,
    opportunities: "scrum-master,other-positions-with-asvpm,scrum-team-member-developer",
    opportunitiesFormScore: 1,
    opportunitiesAssignedScore: 1,
    gain: "Experience, community and support",
    gainFormScore: 0,
    gainAssignedScore: 0,
    certification: "NONE",
    certificationFormScore: 0,
    certificationAssignedScore: 0,
    PMI: "NONE",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "NONE",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "Google search",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments: "I'm excited to participate, learn and give back. Thank you",
    commentsFormScore: 1,
    commentsAssignedScore: 1,
  },
  {
    id: 32,
    submitDate: "10/24/2023",
    fName: "Lamont",
    lName: "Keys",
    email: "Ldkeys77@msn.com",
    phone: "4108008221",
    city: "Baltimore",
    state: "MD",
    country: "United States",
    linkedIn: "www.linkedin.com/in/ lamont-keys-7624a87",
    employmentStatus: "Returning to Job Market",
    employmentFormScore: 1,
    employmentAssignedScore: 1,
    timeCommit: "10",
    timeCommitFormScore: 0,
    timeCommitAssignedScore: 0,
    opportunities: "scrum-team-member-developer,scrum-master,scrum-product-owner",
    opportunitiesFormScore: 1,
    opportunitiesAssignedScore: 1,
    gain: "I would like to learn more about the accountables in particular the Scrum master. I am eager to get knowledge and experience to take to the job market to be gainfully employed. I would like the experience",
    gainFormScore: 0,
    gainAssignedScore: 0,
    certification: "none",
    certificationFormScore: 0,
    certificationAssignedScore: 0,
    PMI: "none",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "none",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "a colleague",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments: "",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
  {
    id: 33,
    submitDate: "11/7/2023",
    fName: "Nghia",
    lName: "Le",
    email: "neil@silversea-analytics.com",
    phone: "+84703378586",
    city: "Ho Chi Minh City",
    state: "Asia",
    country: "Viet Nam",
    linkedIn: "https://www.linkedin.com/in/songnghia0312/",
    employmentStatus: "Full Time",
    employmentFormScore: -2,
    employmentAssignedScore: -2,
    timeCommit: "20-28 hours/week, 4 hours/day",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities:
      "scrum-team-member-developer,scrum-master,scrum-product-owner,other-positions-with-asvpm",
    opportunitiesFormScore: 1,
    opportunitiesAssignedScore: 1,
    gain: "I have been working as a Business Analyst in the IT industry for two years now and am currently in the process of thriving to achieve my long-term goal of being a Product Owner; therefore, by participating in the SVPM Scrum Team Volunteer Program, I am looking forward to learning more about the following aspects:\n  + Technical skills\n  + Project planning and management\n  + Collaboration\nAnd as well as all the new things that would come on my journey in the program.",
    gainFormScore: 0,
    gainAssignedScore: 0,
    certification: "NONE",
    certificationFormScore: 0,
    certificationAssignedScore: 0,
    PMI: "NONE",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "NONE",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "I heard about the SVPM Scrum Team Program from my boss.",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments: "",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
  {
    id: 34,
    submitDate: "11/28/2023",
    fName: "Shibu",
    lName: "Elias",
    email: "shibuelias13@gmail.com",
    phone: "+13414003515",
    city: "Columbia",
    state: "MO",
    country: "United States",
    linkedIn:
      "https://www.linkedin.com/in/shibu-elias-136461140?utm_source=share&amp;amp;utm_campaign=share_via&amp;amp;utm_content=profile&amp;amp;utm_medium=ios_app",
    employmentStatus: "Full Time",
    employmentFormScore: -2,
    employmentAssignedScore: -2,
    timeCommit: "10 to 16 hours/week",
    timeCommitFormScore: 3,
    timeCommitAssignedScore: 3,
    opportunities: "scrum-team-member-developer,scrum-master,scrum-product-owner",
    opportunitiesFormScore: 1,
    opportunitiesAssignedScore: 1,
    gain: "I am looking in to learn new things to have better experience and have a succeed in this field.",
    gainFormScore: 0,
    gainAssignedScore: 0,
    certification: "None",
    certificationFormScore: 0,
    certificationAssignedScore: 0,
    PMI: "None",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "None",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "Online search and researching",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments: "",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
  {
    id: 35,
    submitDate: "10/18/2023",
    fName: "Gift",
    lName: "Nyeduko",
    email: "ugnyeduko@gmail.com",
    phone: "+2348052471241",
    city: "Kubwa",
    state: "Africa",
    country: "Nigeria",
    linkedIn: "https://www.linkedin.com/in/gift-nyeduko-658755206",
    employmentStatus: "Between Jobs In Transition",
    employmentFormScore: -2,
    employmentAssignedScore: -2,
    timeCommit: "5-8 hours/week",
    timeCommitFormScore: 2,
    timeCommitAssignedScore: 2,
    opportunities: "scrum-team-member-developer",
    opportunitiesFormScore: 1,
    opportunitiesAssignedScore: 1,
    gain: "As a newly transitioned Scrum Master, I am eagerly looking forward to learning more and building on my current skills and experience like communication,  facilitation of Scrum ceremonies, collaboration, coaching, user story gathering, product backlog grroming, stakeholder management, among others, through the SVPM Scrum Team Volunteer Program. Also, by working in a cross-functional team, as well as being able to step into new roles such as that of a Developer, i hope to function better as a well grounded Scrum Master in knowing and understanding the needs of any Scrum Team I become part of. As I also prepare to write my PSM certification exam, I hope to gain more knowledge to help pass the exam, through the hands-on experience from the SVPM Scrum Team program.",
    gainFormScore: 0,
    gainAssignedScore: 0,
    certification: "NONE",
    certificationFormScore: 0,
    certificationAssignedScore: 0,
    PMI: "NONE",
    PMIFormScore: 0,
    PMIAssignedScore: 0,
    agileCert: "NONE",
    agileCertFormScore: 0,
    agileCertAssignedScore: 0,
    sprintCommit: "Yes",
    sprintCommitFormScore: 1,
    sprintCommitAssignedScore: 1,
    startInAWeek: "Yes",
    earliestAvalbale: "",
    hear: "I heard about the SVPM Scrum Team Program via a post made by one of my LinkedIn connections who just completed the program.",
    hearFormScore: 0,
    hearAssignedScore: 0,
    comments: "",
    commentsFormScore: 0,
    commentsAssignedScore: 0,
  },
];

// const rows = [
//   {
//     id: 1,
//     submitDate: "10/31/2023",
//     fName: "Abirami",
//     lName: "Chockalingam",
//     email: "chockalingam.a@northeastern.edu",
//     phone: "+16507891991",
//     city: "San Jose",
//     state: "CA",
//     country: "United States",
//     linkedIn: "https://www.linkedin.com/in/abirami-chockalingam",
//     employmentStatus: "Student,Graduate Seeking Employment",
//     employmentFormScore: 1,
//     employmentAssignedScore: 1,
//     timeCommit: "15hours/week",
//     timeCommitFormScore: 3,
//     timeCommitAssignedScore: 3,
//     opportunities:
//       "scrum-team-member-developer,scrum-master,scrum-product-owner,other-positions-with-asvpm",
//     opportunitiesFormScore: 1,
//     opportunitiesAssignedScore: 1,
//     gain: "To practice Agile and implement them on a daily basis",
//     gainFormScore: 1,
//     gainAssignedScore: 1,
//     certification: "CSM(Scrumalliance.org)",
//     certificationFormScore: 1,
//     certificationAssignedScore: 1,
//     PMI: "Working towards CAPM",
//     PMIFormScore: 0,
//     PMIAssignedScore: 0,
//     agileCert: "NONE",
//     agileCertFormScore: 0,
//     agileCertAssignedScore: 0,
//     sprintCommit: "YES",
//     sprintCommitFormScore: 1,
//     sprintCommitAssignedScore: 1,
//     startInAWeek: "YES",
//     earliestAvalbale: "",
//     hear: "Through Prof. David and I was working for more than 6months with CAM Team",
//     hearFormScore: 2,
//     hearAssignedScore: 2,
//     comments: "I am a returning member of the CAM Team",
//     commentsFormScore: 1,
//     commentsAssignedScore: 1,
//   },
//   {
//     id: 2,
//     submitDate: "10/31/2023",
//     fName: "Dr",
//     lName: "Suman",
//     email: "drfnusuman@gmail.com",
//     phone: "6692644074",
//     city: "Sunnyvale",
//     state: "CA",
//     country: "United States",
//     linkedIn:
//       "https://www.linkedin.com/in/suman-ph-d-physics-mba-pmp-acp-itil4-0b75b4126/",
//     employmentStatus: "Between Jobs In Transition, Full Time",
//     employmentFormScore: -2,
//     employmentAssignedScore: -2,
//     timeCommit: "6-8 hours/week",
//     timeCommitFormScore: 3,
//     timeCommitAssignedScore: 3,
//     opportunities: "scrum-master,scrum-product-owner,other-positions-with-asvpm",
//     opportunitiesFormScore: 0,
//     opportunitiesAssignedScore: 0,
//     gain: "I like collaboration with diverse individuals. The IT field is constantly evolving, I am keen to learn and share new latest trends and technologies. Streamlining processes, optimizing resources, and improving project management practices to increase efficiency and reduce waste are something I often strive for and find passion in.",
//     gainFormScore: 2,
//     gainAssignedScore: 2,
//     certification: "CSM",
//     certificationFormScore: 1,
//     certificationAssignedScore: 1,
//     PMI: "PMP, and PMI - ACP",
//     PMIFormScore: 1,
//     PMIAssignedScore: 1,
//     agileCert: "SAFe",
//     agileCertFormScore: 1,
//     agileCertAssignedScore: 1,
//     sprintCommit: "YES",
//     sprintCommitFormScore: 1,
//     sprintCommitAssignedScore: 1,
//     startInAWeek: "YES",
//     earliestAvalbale: "",
//     hear: "David (Davood) Bakhtnia",
//     hearFormScore: 2,
//     hearAssignedScore: 2,
//     comments: "Looking forward to being a part of SVPM",
//     commentsFormScore: 1,
//     commentsAssignedScore: 1,
//   },
//   {
//     id: 3,
//     submitDate: "10/19/2023",
//     fName: "JOY",
//     lName: "ONIGBOGI",
//     email: "joy@sdedigital.com",
//     phone: "7956438972",
//     city: "London",
//     state: "Europe",
//     country: "United Kingdom",
//     linkedIn: "www.linkedin.com/in/joy-onigbogi-cmgr-csm-cspo-718433199",
//     employmentStatus: "Part Time",
//     employmentFormScore: 0,
//     employmentAssignedScore: 0,
//     timeCommit: "10-12 hours/week",
//     timeCommitFormScore: 3,
//     timeCommitAssignedScore: 3,
//     opportunities:
//       "scrum-team-member-developer,scrum-master,scrum-product-owner,other-positions-with-asvpm",
//     opportunitiesFormScore: 1,
//     opportunitiesAssignedScore: 1,
//     gain: "I am looking to practice Agile and move with current trends",
//     gainFormScore: 1,
//     gainAssignedScore: 1,
//     certification: "CSM, CSPO",
//     certificationFormScore: 2,
//     certificationAssignedScore: 2,
//     PMI: "NONE",
//     PMIFormScore: 0,
//     PMIAssignedScore: 0,
//     agileCert: "NONE",
//     agileCertFormScore: 0,
//     agileCertAssignedScore: 0,
//     sprintCommit: "YES",
//     sprintCommitFormScore: 1,
//     sprintCommitAssignedScore: 1,
//     startInAWeek: "YES",
//     earliestAvalbale: "",
//     hear: "Referral - Delaine Moore",
//     hearFormScore: 1,
//     hearAssignedScore: 1,
//     comments: "",
//     commentsFormScore: 0,
//     commentsAssignedScore: 0,
//   },
//   {
//     id: 4,
//     submitDate: "11/17/2023",
//     fName: "Jaives",
//     lName: "Lundy",
//     email: "jai.lundy@gmail.com",
//     phone: "3364931406",
//     city: "Winston Salem",
//     state: "NC",
//     country: "United States",
//     linkedIn: "https://www.linkedin.com/in/jaiveslundy",
//     employmentStatus: "Between Jobs In Transition",
//     employmentFormScore: 1,
//     employmentAssignedScore: 1,
//     timeCommit: "15-20 Hours/Week",
//     timeCommitFormScore: 3,
//     timeCommitAssignedScore: 3,
//     opportunities: "scrum-team-member-developer,scrum-master",
//     opportunitiesFormScore: 1,
//     opportunitiesAssignedScore: 1,
//     gain: "I am looking to further refine my scrum master experience, as my last two positions as a scrum master was implementing scrum in a telecommunications company. I want to improve my skills in a fully agile environment.",
//     gainFormScore: 1,
//     gainAssignedScore: 1,
//     certification: "CSM (scrumalliance.org)",
//     certificationFormScore: 1,
//     certificationAssignedScore: 1,
//     PMI: "NONE",
//     PMIFormScore: 0,
//     PMIAssignedScore: 0,
//     agileCert: "NONE",
//     agileCertFormScore: 0,
//     agileCertAssignedScore: 0,
//     sprintCommit: "YES",
//     sprintCommitFormScore: 1,
//     sprintCommitAssignedScore: 1,
//     startInAWeek: "YES",
//     earliestAvalbale: "",
//     hear: "My LinkedIn connection Eddie Drew was a volunteer and recommended SVPM to me.",
//     hearFormScore: 1,
//     hearAssignedScore: 1,
//     comments: "",
//     commentsFormScore: 0,
//     commentsAssignedScore: 0,
//   },
//   {
//     id: 5,
//     submitDate: "11/1/2023",
//     fName: "Ifeyinwa",
//     lName: "Okade",
//     email: "ipokade@yahoo.com",
//     phone: "19197584323",
//     city: "Raleigh",
//     state: "NC",
//     country: "United States",
//     linkedIn: "www.linkedin.com/in/ify-okade",
//     employmentStatus: "Between Jobs In Transition,Returning to Job Market",
//     employmentFormScore: 1,
//     employmentAssignedScore: 1,
//     timeCommit: "8-16 hours",
//     timeCommitFormScore: 3,
//     timeCommitAssignedScore: 3,
//     opportunities: "scrum-master",
//     opportunitiesFormScore: 0,
//     opportunitiesAssignedScore: 0,
//     gain: "I am looking for a chance to hone my skills, gain more experience, and immerse myself in the Agile world",
//     gainFormScore: 1,
//     gainAssignedScore: 1,
//     certification: "CSM",
//     certificationFormScore: 1,
//     certificationAssignedScore: 1,
//     PMI: "NONE",
//     PMIFormScore: 0,
//     PMIAssignedScore: 0,
//     agileCert: "NONE",
//     agileCertFormScore: 0,
//     agileCertAssignedScore: 0,
//     sprintCommit: "YES",
//     sprintCommitFormScore: 1,
//     sprintCommitAssignedScore: 1,
//     startInAWeek: "YES",
//     earliestAvalbale: "",
//     hear: "From a Google search for Scrum master volunteer positions",
//     hearFormScore: 0,
//     hearAssignedScore: 0,
//     comments:
//       "I'm excited to embark on this journey of growth and learning. As a passionate advocate for continuous improvement, I look forward to challenging myself, embracing the Agile principles, and contributing my best to the team. I believe that every experience, no matter how small, can be a stepping stone to professional excellence. I value the importance of open communication, teamwork, and collaboration, as these principles lie at the core of Agile methodology.",
//     commentsFormScore: 2,
//     commentsAssignedScore: 2,
//   },
//   {
//     id: 6,
//     submitDate: "10/17/2023",
//     fName: "Shibha",
//     lName: "Tyagi",
//     email: "txshibha@gmail.com",
//     phone: "4698470186",
//     city: "Plano",
//     state: "TX",
//     country: "United States",
//     linkedIn: "https://www.linkedin.com/in/shibha-tyagi-55059616/",
//     employmentStatus: "Between Jobs In Transition",
//     employmentFormScore: 1,
//     employmentAssignedScore: 1,
//     timeCommit: "16 - 20 hours/ week",
//     timeCommitFormScore: 3,
//     timeCommitAssignedScore: 3,
//     opportunities: "scrum-master",
//     opportunitiesFormScore: 0,
//     opportunitiesAssignedScore: 0,
//     gain: "- Contribute in any possible way - Hands on experience - Knowledge Gain and Skill Development - Mentorship",
//     gainFormScore: 1,
//     gainAssignedScore: 1,
//     certification: "CSM(Scrumalliance.org)",
//     certificationFormScore: 1,
//     certificationAssignedScore: 1,
//     PMI: "NONE",
//     PMIFormScore: 0,
//     PMIAssignedScore: 0,
//     agileCert: "NONE",
//     agileCertFormScore: 0,
//     agileCertAssignedScore: 0,
//     sprintCommit: "YES",
//     sprintCommitFormScore: 1,
//     sprintCommitAssignedScore: 1,
//     startInAWeek: "YES",
//     earliestAvalbale: "",
//     hear: "Referral from a friend",
//     hearFormScore: 0,
//     hearAssignedScore: 0,
//     comments:
//       "I am eager to learn and grow in a Scrum environment, gain valuable experience, and make a positive impact on the projects I'll be involved in. I believe that this experience will not only enhance my skills but also allow me to contribute to my employer's success and make a real difference. I look forward to the challenges and opportunities this program will offer, and I'm committed to giving it my all. Please let me know if there are any initial steps or preparations I should be aware of before we get started. I'm ready to dive in and make the most of this incredible opportunity.",
//     commentsFormScore: 1,
//     commentsAssignedScore: 1,
//   },

//   {
//     id: 7,
//     submitDate: "10/26/2023",
//     fName: "Abimbola",
//     lName: "Unah",
//     email: "Abimunah@gmail.com",
//     phone: "4042875223",
//     city: "Suwanee",
//     state: "GA",
//     country: "United States",
//     linkedIn: "https://www.linkedin.com/in/abimbola-u-b689b360",
//     employmentStatus: "",
//     employmentFormScore: 1,
//     employmentAssignedScore: 1,
//     timeCommit: "",
//     timeCommitFormScore: 3,
//     timeCommitAssignedScore: 3,
//     opportunities: "",
//     opportunitiesFormScore: 0,
//     opportunitiesAssignedScore: 0,
//     gain: "",
//     gainFormScore: 1,
//     gainAssignedScore: 1,
//     certification: "CSM(Scrumalliance.org)",
//     certificationFormScore: 1,
//     certificationAssignedScore: 1,
//     PMI: "NONE",
//     PMIFormScore: 0,
//     PMIAssignedScore: 0,
//     agileCert: "NONE",
//     agileCertFormScore: 0,
//     agileCertAssignedScore: 0,
//     sprintCommit: "YES",
//     sprintCommitFormScore: 1,
//     sprintCommitAssignedScore: 1,
//     startInAWeek: "YES",
//     earliestAvalbale: "",
//     hear: "Referral from a friend",
//     hearFormScore: 0,
//     hearAssignedScore: 0,
//     comments:
//       "I am eager to learn and grow in a Scrum environment, gain valuable experience, and make a positive impact on the projects I'll be involved in. I believe that this experience will not only enhance my skills but also allow me to contribute to my employer's success and make a real difference. I look forward to the challenges and opportunities this program will offer, and I'm committed to giving it my all. Please let me know if there are any initial steps or preparations I should be aware of before we get started. I'm ready to dive in and make the most of this incredible opportunity.",
//     commentsFormScore: 1,
//     commentsAssignedScore: 1,
//   },

//   {
//     id: 8,
//     submitDate: "10/26/2023",
//     fName: "Ladreama",
//     lName: "Perry",
//     email: "ladreamaperry016@gmail.com",
//     phone: "2523702555",
//     city: "Greenville",
//     state: "NC",
//     country: "United States",
//     linkedIn:
//       "https://www.linkedin.com/in/ladreama-perry-482095b2?utm_source=share&amp;amp;utm_campaign=share_via&amp;amp;utm_content=profile&amp;amp;utm_medium=ios_app",
//     employmentStatus: "",
//     employmentFormScore: 1,
//     employmentAssignedScore: 1,
//     timeCommit: "",
//     timeCommitFormScore: 3,
//     timeCommitAssignedScore: 3,
//     opportunities: "",
//     opportunitiesFormScore: 0,
//     opportunitiesAssignedScore: 0,
//     gain: "",
//     gainFormScore: 1,
//     gainAssignedScore: 1,
//     certification: "CSM(Scrumalliance.org)",
//     certificationFormScore: 1,
//     certificationAssignedScore: 1,
//     PMI: "NONE",
//     PMIFormScore: 0,
//     PMIAssignedScore: 0,
//     agileCert: "NONE",
//     agileCertFormScore: 0,
//     agileCertAssignedScore: 0,
//     sprintCommit: "YES",
//     sprintCommitFormScore: 1,
//     sprintCommitAssignedScore: 1,
//     startInAWeek: "YES",
//     earliestAvalbale: "",
//     hear: "Referral from a friend",
//     hearFormScore: 0,
//     hearAssignedScore: 0,
//     comments:
//       "I am eager to learn and grow in a Scrum environment, gain valuable experience, and make a positive impact on the projects I'll be involved in. I believe that this experience will not only enhance my skills but also allow me to contribute to my employer's success and make a real difference. I look forward to the challenges and opportunities this program will offer, and I'm committed to giving it my all. Please let me know if there are any initial steps or preparations I should be aware of before we get started. I'm ready to dive in and make the most of this incredible opportunity.",
//     commentsFormScore: 1,
//     commentsAssignedScore: 1,
//   },

//   {
//     id: 9,
//     submitDate: "10/30/2023",
//     fName: "Akansha",
//     lName: "Saluru",
//     email: "akansha_saluru@hotmail.com",
//     phone: "3659982857",
//     city: "Brampton",
//     state: "In Canada",
//     country: "Canada",
//     linkedIn: "https://www.linkedin.com/in/akansha-s/",
//     employmentStatus: "",
//     employmentFormScore: 1,
//     employmentAssignedScore: 1,
//     timeCommit: "",
//     timeCommitFormScore: 3,
//     timeCommitAssignedScore: 3,
//     opportunities: "",
//     opportunitiesFormScore: 0,
//     opportunitiesAssignedScore: 0,
//     gain: "",
//     gainFormScore: 1,
//     gainAssignedScore: 1,
//     certification: "CSM(Scrumalliance.org)",
//     certificationFormScore: 1,
//     certificationAssignedScore: 1,
//     PMI: "NONE",
//     PMIFormScore: 0,
//     PMIAssignedScore: 0,
//     agileCert: "NONE",
//     agileCertFormScore: 0,
//     agileCertAssignedScore: 0,
//     sprintCommit: "YES",
//     sprintCommitFormScore: 1,
//     sprintCommitAssignedScore: 1,
//     startInAWeek: "YES",
//     earliestAvalbale: "",
//     hear: "Referral from a friend",
//     hearFormScore: 0,
//     hearAssignedScore: 0,
//     comments:
//       "I am eager to learn and grow in a Scrum environment, gain valuable experience, and make a positive impact on the projects I'll be involved in. I believe that this experience will not only enhance my skills but also allow me to contribute to my employer's success and make a real difference. I look forward to the challenges and opportunities this program will offer, and I'm committed to giving it my all. Please let me know if there are any initial steps or preparations I should be aware of before we get started. I'm ready to dive in and make the most of this incredible opportunity.",
//     commentsFormScore: 1,
//     commentsAssignedScore: 1,
//   },

//   {
//     id: 10,
//     submitDate: "11/5/2023",
//     fName: "Anastasia",
//     lName: "Hasan",
//     email: "anastasiahasan@yahoo.com",
//     phone: "213-671-3811",
//     city: "palm desert",
//     state: "CA",
//     country: "United States",
//     linkedIn: "NONE",
//     employmentStatus: "",
//     employmentFormScore: 1,
//     employmentAssignedScore: 1,
//     timeCommit: "",
//     timeCommitFormScore: 3,
//     timeCommitAssignedScore: 3,
//     opportunities: "",
//     opportunitiesFormScore: 0,
//     opportunitiesAssignedScore: 0,
//     gain: "",
//     gainFormScore: 1,
//     gainAssignedScore: 1,
//     certification: "CSM(Scrumalliance.org)",
//     certificationFormScore: 1,
//     certificationAssignedScore: 1,
//     PMI: "NONE",
//     PMIFormScore: 0,
//     PMIAssignedScore: 0,
//     agileCert: "NONE",
//     agileCertFormScore: 0,
//     agileCertAssignedScore: 0,
//     sprintCommit: "YES",
//     sprintCommitFormScore: 1,
//     sprintCommitAssignedScore: 1,
//     startInAWeek: "YES",
//     earliestAvalbale: "",
//     hear: "Referral from a friend",
//     hearFormScore: 0,
//     hearAssignedScore: 0,
//     comments:
//       "I am eager to learn and grow in a Scrum environment, gain valuable experience, and make a positive impact on the projects I'll be involved in. I believe that this experience will not only enhance my skills but also allow me to contribute to my employer's success and make a real difference. I look forward to the challenges and opportunities this program will offer, and I'm committed to giving it my all. Please let me know if there are any initial steps or preparations I should be aware of before we get started. I'm ready to dive in and make the most of this incredible opportunity.",
//     commentsFormScore: 1,
//     commentsAssignedScore: 1,
//   },

//   {
//     id: 11,
//     submitDate: "11/21/2023",
//     fName: "Andrea",
//     lName: "Romain",
//     email: "",
//     phone: "",
//     city: "",
//     state: "",
//     country: "United States",
//     linkedIn: "",
//     employmentStatus: "",
//     employmentFormScore: 1,
//     employmentAssignedScore: 1,
//     timeCommit: "",
//     timeCommitFormScore: 3,
//     timeCommitAssignedScore: 3,
//     opportunities: "",
//     opportunitiesFormScore: 0,
//     opportunitiesAssignedScore: 0,
//     gain: "",
//     gainFormScore: 1,
//     gainAssignedScore: 1,
//     certification: "CSM(Scrumalliance.org)",
//     certificationFormScore: 1,
//     certificationAssignedScore: 1,
//     PMI: "NONE",
//     PMIFormScore: 0,
//     PMIAssignedScore: 0,
//     agileCert: "NONE",
//     agileCertFormScore: 0,
//     agileCertAssignedScore: 0,
//     sprintCommit: "YES",
//     sprintCommitFormScore: 1,
//     sprintCommitAssignedScore: 1,
//     startInAWeek: "YES",
//     earliestAvalbale: "",
//     hear: "Referral from a friend",
//     hearFormScore: 0,
//     hearAssignedScore: 0,
//     comments:
//       "I am eager to learn and grow in a Scrum environment, gain valuable experience, and make a positive impact on the projects I'll be involved in. I believe that this experience will not only enhance my skills but also allow me to contribute to my employer's success and make a real difference. I look forward to the challenges and opportunities this program will offer, and I'm committed to giving it my all. Please let me know if there are any initial steps or preparations I should be aware of before we get started. I'm ready to dive in and make the most of this incredible opportunity.",
//     commentsFormScore: 1,
//     commentsAssignedScore: 1,
//   },

//   {
//     id: 12,
//     submitDate: "",
//     fName: "",
//     lName: "",
//     email: "",
//     phone: "",
//     city: "",
//     state: "",
//     country: "United States",
//     linkedIn: "",
//     employmentStatus: "",
//     employmentFormScore: 1,
//     employmentAssignedScore: 1,
//     timeCommit: "",
//     timeCommitFormScore: 3,
//     timeCommitAssignedScore: 3,
//     opportunities: "",
//     opportunitiesFormScore: 0,
//     opportunitiesAssignedScore: 0,
//     gain: "",
//     gainFormScore: 1,
//     gainAssignedScore: 1,
//     certification: "CSM(Scrumalliance.org)",
//     certificationFormScore: 1,
//     certificationAssignedScore: 1,
//     PMI: "NONE",
//     PMIFormScore: 0,
//     PMIAssignedScore: 0,
//     agileCert: "NONE",
//     agileCertFormScore: 0,
//     agileCertAssignedScore: 0,
//     sprintCommit: "YES",
//     sprintCommitFormScore: 1,
//     sprintCommitAssignedScore: 1,
//     startInAWeek: "YES",
//     earliestAvalbale: "",
//     hear: "Referral from a friend",
//     hearFormScore: 0,
//     hearAssignedScore: 0,
//     comments:
//       "I am eager to learn and grow in a Scrum environment, gain valuable experience, and make a positive impact on the projects I'll be involved in. I believe that this experience will not only enhance my skills but also allow me to contribute to my employer's success and make a real difference. I look forward to the challenges and opportunities this program will offer, and I'm committed to giving it my all. Please let me know if there are any initial steps or preparations I should be aware of before we get started. I'm ready to dive in and make the most of this incredible opportunity.",
//     commentsFormScore: 1,
//     commentsAssignedScore: 1,
//   },

//   {
//     id: 13,
//     submitDate: "",
//     fName: "",
//     lName: "",
//     email: "",
//     phone: "",
//     city: "",
//     state: "",
//     country: "United States",
//     linkedIn: "",
//     employmentStatus: "",
//     employmentFormScore: 1,
//     employmentAssignedScore: 1,
//     timeCommit: "",
//     timeCommitFormScore: 3,
//     timeCommitAssignedScore: 3,
//     opportunities: "",
//     opportunitiesFormScore: 0,
//     opportunitiesAssignedScore: 0,
//     gain: "",
//     gainFormScore: 1,
//     gainAssignedScore: 1,
//     certification: "CSM(Scrumalliance.org)",
//     certificationFormScore: 1,
//     certificationAssignedScore: 1,
//     PMI: "NONE",
//     PMIFormScore: 0,
//     PMIAssignedScore: 0,
//     agileCert: "NONE",
//     agileCertFormScore: 0,
//     agileCertAssignedScore: 0,
//     sprintCommit: "YES",
//     sprintCommitFormScore: 1,
//     sprintCommitAssignedScore: 1,
//     startInAWeek: "YES",
//     earliestAvalbale: "",
//     hear: "Referral from a friend",
//     hearFormScore: 0,
//     hearAssignedScore: 0,
//     comments:
//       "I am eager to learn and grow in a Scrum environment, gain valuable experience, and make a positive impact on the projects I'll be involved in. I believe that this experience will not only enhance my skills but also allow me to contribute to my employer's success and make a real difference. I look forward to the challenges and opportunities this program will offer, and I'm committed to giving it my all. Please let me know if there are any initial steps or preparations I should be aware of before we get started. I'm ready to dive in and make the most of this incredible opportunity.",
//     commentsFormScore: 1,
//     commentsAssignedScore: 1,
//   },

//   {
//     id: 14,
//     submitDate: "",
//     fName: "",
//     lName: "",
//     email: "",
//     phone: "",
//     city: "",
//     state: "",
//     country: "United States",
//     linkedIn: "",
//     employmentStatus: "",
//     employmentFormScore: 1,
//     employmentAssignedScore: 1,
//     timeCommit: "",
//     timeCommitFormScore: 3,
//     timeCommitAssignedScore: 3,
//     opportunities: "",
//     opportunitiesFormScore: 0,
//     opportunitiesAssignedScore: 0,
//     gain: "",
//     gainFormScore: 1,
//     gainAssignedScore: 1,
//     certification: "CSM(Scrumalliance.org)",
//     certificationFormScore: 1,
//     certificationAssignedScore: 1,
//     PMI: "NONE",
//     PMIFormScore: 0,
//     PMIAssignedScore: 0,
//     agileCert: "NONE",
//     agileCertFormScore: 0,
//     agileCertAssignedScore: 0,
//     sprintCommit: "YES",
//     sprintCommitFormScore: 1,
//     sprintCommitAssignedScore: 1,
//     startInAWeek: "YES",
//     earliestAvalbale: "",
//     hear: "Referral from a friend",
//     hearFormScore: 0,
//     hearAssignedScore: 0,
//     comments:
//       "I am eager to learn and grow in a Scrum environment, gain valuable experience, and make a positive impact on the projects I'll be involved in. I believe that this experience will not only enhance my skills but also allow me to contribute to my employer's success and make a real difference. I look forward to the challenges and opportunities this program will offer, and I'm committed to giving it my all. Please let me know if there are any initial steps or preparations I should be aware of before we get started. I'm ready to dive in and make the most of this incredible opportunity.",
//     commentsFormScore: 1,
//     commentsAssignedScore: 1,
//   },

//   {
//     id: 15,
//     submitDate: "",
//     fName: "",
//     lName: "",
//     email: "",
//     phone: "",
//     city: "",
//     state: "",
//     country: "United States",
//     linkedIn: "",
//     employmentStatus: "",
//     employmentFormScore: 1,
//     employmentAssignedScore: 1,
//     timeCommit: "",
//     timeCommitFormScore: 3,
//     timeCommitAssignedScore: 3,
//     opportunities: "",
//     opportunitiesFormScore: 0,
//     opportunitiesAssignedScore: 0,
//     gain: "",
//     gainFormScore: 1,
//     gainAssignedScore: 1,
//     certification: "CSM(Scrumalliance.org)",
//     certificationFormScore: 1,
//     certificationAssignedScore: 1,
//     PMI: "NONE",
//     PMIFormScore: 0,
//     PMIAssignedScore: 0,
//     agileCert: "NONE",
//     agileCertFormScore: 0,
//     agileCertAssignedScore: 0,
//     sprintCommit: "YES",
//     sprintCommitFormScore: 1,
//     sprintCommitAssignedScore: 1,
//     startInAWeek: "YES",
//     earliestAvalbale: "",
//     hear: "Referral from a friend",
//     hearFormScore: 0,
//     hearAssignedScore: 0,
//     comments:
//       "I am eager to learn and grow in a Scrum environment, gain valuable experience, and make a positive impact on the projects I'll be involved in. I believe that this experience will not only enhance my skills but also allow me to contribute to my employer's success and make a real difference. I look forward to the challenges and opportunities this program will offer, and I'm committed to giving it my all. Please let me know if there are any initial steps or preparations I should be aware of before we get started. I'm ready to dive in and make the most of this incredible opportunity.",
//     commentsFormScore: 1,
//     commentsAssignedScore: 1,
//   },

//   {
//     id: 16,
//     submitDate: "",
//     fName: "",
//     lName: "",
//     email: "",
//     phone: "",
//     city: "",
//     state: "",
//     country: "United States",
//     linkedIn: "",
//     employmentStatus: "",
//     employmentFormScore: 1,
//     employmentAssignedScore: 1,
//     timeCommit: "",
//     timeCommitFormScore: 3,
//     timeCommitAssignedScore: 3,
//     opportunities: "",
//     opportunitiesFormScore: 0,
//     opportunitiesAssignedScore: 0,
//     gain: "",
//     gainFormScore: 1,
//     gainAssignedScore: 1,
//     certification: "CSM(Scrumalliance.org)",
//     certificationFormScore: 1,
//     certificationAssignedScore: 1,
//     PMI: "NONE",
//     PMIFormScore: 0,
//     PMIAssignedScore: 0,
//     agileCert: "NONE",
//     agileCertFormScore: 0,
//     agileCertAssignedScore: 0,
//     sprintCommit: "YES",
//     sprintCommitFormScore: 1,
//     sprintCommitAssignedScore: 1,
//     startInAWeek: "YES",
//     earliestAvalbale: "",
//     hear: "Referral from a friend",
//     hearFormScore: 0,
//     hearAssignedScore: 0,
//     comments:
//       "I am eager to learn and grow in a Scrum environment, gain valuable experience, and make a positive impact on the projects I'll be involved in. I believe that this experience will not only enhance my skills but also allow me to contribute to my employer's success and make a real difference. I look forward to the challenges and opportunities this program will offer, and I'm committed to giving it my all. Please let me know if there are any initial steps or preparations I should be aware of before we get started. I'm ready to dive in and make the most of this incredible opportunity.",
//     commentsFormScore: 1,
//     commentsAssignedScore: 1,
//   },

//   {
//     id: 17,
//     submitDate: "",
//     fName: "",
//     lName: "",
//     email: "",
//     phone: "",
//     city: "",
//     state: "",
//     country: "United States",
//     linkedIn: "",
//     employmentStatus: "",
//     employmentFormScore: 1,
//     employmentAssignedScore: 1,
//     timeCommit: "",
//     timeCommitFormScore: 3,
//     timeCommitAssignedScore: 3,
//     opportunities: "",
//     opportunitiesFormScore: 0,
//     opportunitiesAssignedScore: 0,
//     gain: "",
//     gainFormScore: 1,
//     gainAssignedScore: 1,
//     certification: "CSM(Scrumalliance.org)",
//     certificationFormScore: 1,
//     certificationAssignedScore: 1,
//     PMI: "NONE",
//     PMIFormScore: 0,
//     PMIAssignedScore: 0,
//     agileCert: "NONE",
//     agileCertFormScore: 0,
//     agileCertAssignedScore: 0,
//     sprintCommit: "YES",
//     sprintCommitFormScore: 1,
//     sprintCommitAssignedScore: 1,
//     startInAWeek: "YES",
//     earliestAvalbale: "",
//     hear: "Referral from a friend",
//     hearFormScore: 0,
//     hearAssignedScore: 0,
//     comments:
//       "I am eager to learn and grow in a Scrum environment, gain valuable experience, and make a positive impact on the projects I'll be involved in. I believe that this experience will not only enhance my skills but also allow me to contribute to my employer's success and make a real difference. I look forward to the challenges and opportunities this program will offer, and I'm committed to giving it my all. Please let me know if there are any initial steps or preparations I should be aware of before we get started. I'm ready to dive in and make the most of this incredible opportunity.",
//     commentsFormScore: 1,
//     commentsAssignedScore: 1,
//   },

//   {
//     id: 18,
//     submitDate: "",
//     fName: "",
//     lName: "",
//     email: "",
//     phone: "",
//     city: "",
//     state: "",
//     country: "United States",
//     linkedIn: "",
//     employmentStatus: "",
//     employmentFormScore: 1,
//     employmentAssignedScore: 1,
//     timeCommit: "",
//     timeCommitFormScore: 3,
//     timeCommitAssignedScore: 3,
//     opportunities: "",
//     opportunitiesFormScore: 0,
//     opportunitiesAssignedScore: 0,
//     gain: "",
//     gainFormScore: 1,
//     gainAssignedScore: 1,
//     certification: "CSM(Scrumalliance.org)",
//     certificationFormScore: 1,
//     certificationAssignedScore: 1,
//     PMI: "NONE",
//     PMIFormScore: 0,
//     PMIAssignedScore: 0,
//     agileCert: "NONE",
//     agileCertFormScore: 0,
//     agileCertAssignedScore: 0,
//     sprintCommit: "YES",
//     sprintCommitFormScore: 1,
//     sprintCommitAssignedScore: 1,
//     startInAWeek: "YES",
//     earliestAvalbale: "",
//     hear: "Referral from a friend",
//     hearFormScore: 0,
//     hearAssignedScore: 0,
//     comments:
//       "I am eager to learn and grow in a Scrum environment, gain valuable experience, and make a positive impact on the projects I'll be involved in. I believe that this experience will not only enhance my skills but also allow me to contribute to my employer's success and make a real difference. I look forward to the challenges and opportunities this program will offer, and I'm committed to giving it my all. Please let me know if there are any initial steps or preparations I should be aware of before we get started. I'm ready to dive in and make the most of this incredible opportunity.",
//     commentsFormScore: 1,
//     commentsAssignedScore: 1,
//   },

//   {
//     id: 19,
//     submitDate: "",
//     fName: "",
//     lName: "",
//     email: "",
//     phone: "",
//     city: "",
//     state: "",
//     country: "United States",
//     linkedIn: "",
//     employmentStatus: "",
//     employmentFormScore: 1,
//     employmentAssignedScore: 1,
//     timeCommit: "",
//     timeCommitFormScore: 3,
//     timeCommitAssignedScore: 3,
//     opportunities: "",
//     opportunitiesFormScore: 0,
//     opportunitiesAssignedScore: 0,
//     gain: "",
//     gainFormScore: 1,
//     gainAssignedScore: 1,
//     certification: "CSM(Scrumalliance.org)",
//     certificationFormScore: 1,
//     certificationAssignedScore: 1,
//     PMI: "NONE",
//     PMIFormScore: 0,
//     PMIAssignedScore: 0,
//     agileCert: "NONE",
//     agileCertFormScore: 0,
//     agileCertAssignedScore: 0,
//     sprintCommit: "YES",
//     sprintCommitFormScore: 1,
//     sprintCommitAssignedScore: 1,
//     startInAWeek: "YES",
//     earliestAvalbale: "",
//     hear: "Referral from a friend",
//     hearFormScore: 0,
//     hearAssignedScore: 0,
//     comments:
//       "I am eager to learn and grow in a Scrum environment, gain valuable experience, and make a positive impact on the projects I'll be involved in. I believe that this experience will not only enhance my skills but also allow me to contribute to my employer's success and make a real difference. I look forward to the challenges and opportunities this program will offer, and I'm committed to giving it my all. Please let me know if there are any initial steps or preparations I should be aware of before we get started. I'm ready to dive in and make the most of this incredible opportunity.",
//     commentsFormScore: 1,
//     commentsAssignedScore: 1,
//   },

//   {
//     id: 20,
//     submitDate: "",
//     fName: "",
//     lName: "",
//     email: "",
//     phone: "",
//     city: "",
//     state: "",
//     country: "United States",
//     linkedIn: "",
//     employmentStatus: "",
//     employmentFormScore: 1,
//     employmentAssignedScore: 1,
//     timeCommit: "",
//     timeCommitFormScore: 3,
//     timeCommitAssignedScore: 3,
//     opportunities: "",
//     opportunitiesFormScore: 0,
//     opportunitiesAssignedScore: 0,
//     gain: "",
//     gainFormScore: 1,
//     gainAssignedScore: 1,
//     certification: "CSM(Scrumalliance.org)",
//     certificationFormScore: 1,
//     certificationAssignedScore: 1,
//     PMI: "NONE",
//     PMIFormScore: 0,
//     PMIAssignedScore: 0,
//     agileCert: "NONE",
//     agileCertFormScore: 0,
//     agileCertAssignedScore: 0,
//     sprintCommit: "YES",
//     sprintCommitFormScore: 1,
//     sprintCommitAssignedScore: 1,
//     startInAWeek: "YES",
//     earliestAvalbale: "",
//     hear: "Referral from a friend",
//     hearFormScore: 0,
//     hearAssignedScore: 0,
//     comments:
//       "I am eager to learn and grow in a Scrum environment, gain valuable experience, and make a positive impact on the projects I'll be involved in. I believe that this experience will not only enhance my skills but also allow me to contribute to my employer's success and make a real difference. I look forward to the challenges and opportunities this program will offer, and I'm committed to giving it my all. Please let me know if there are any initial steps or preparations I should be aware of before we get started. I'm ready to dive in and make the most of this incredible opportunity.",
//     commentsFormScore: 1,
//     commentsAssignedScore: 1,
//   },
// ];
